export const loadSdk = (type, locale) => {
  return new Promise((resolve, reject) => {
    if (type == "fb") {
      // 删除所有 connect.facebook.net 域的脚本
      const existingScripts = document.querySelectorAll(
        'script[src*="connect.facebook.net"]'
      );
      existingScripts.forEach((script) =>
        script.parentNode.removeChild(script)
      );

      // 生成新的 URL 包含当前时间戳
      const timestamp = Date.now();
      const url = `https://connect.facebook.net/${locale}/sdk.js#xfbml=true&version=v19.0&autoLogAppEvents=1&_=${timestamp}`;

      // 创建并加载新的脚本
      (function (d) {
        var js,
          id = "facebook-jssdk";
        js = d.createElement("script");
        js.id = id;
        js.async = true;
        js.src = url;
        js.onload = resolve; // 脚本加载成功时调用 resolve
        js.onerror = reject; // 脚本加载失败时调用 reject
        d.getElementsByTagName("head")[0].appendChild(js);
      })(document);
    }
  });
};
